import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  container: {
    margin: 10,
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    marginTop: 16,
    paddingHorizontal: 4,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  html: {
    fontSize: 11,
    color: '#262626',
  },
});
